import INoteContentBuilder from "./INoteContentBuilder";
import INoteTag from "./INoteTag";

/**
 * A {@link INoteContentBuilder} which constructs note content based on the configured tags, presented in the same
 * series as they are configured, separated by the configured separator.
 */
class TagSeriesNoteContentBuilder<TNoteProps> implements INoteContentBuilder<TNoteProps> {
  private readonly tags: INoteTag<TNoteProps>[];
  private readonly separator: string;

  /** @param tags - The tags which define how the note content is structured. */
  constructor(tags: INoteTag<TNoteProps>[], separator: string) {
    this.tags = tags;
    this.separator = separator;
  }

  buildNoteContent = (noteProps: TNoteProps) => {
    const tagContent: string[] = [];
    this.tags.forEach(tag => {
      const content = tag.buildTagContent(noteProps);
      if (content) tagContent.push(content);
    });
    return tagContent.join(this.separator);
  };
}

export default TagSeriesNoteContentBuilder;
